import { render, staticRenderFns } from "./PerfilMotorista.vue?vue&type=template&id=0a8a1ace&"
import script from "./PerfilMotorista.vue?vue&type=script&lang=js&"
export * from "./PerfilMotorista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports